<template lang="pug">

  div( class="wrapper wrapper-content" )
    div( class="row justify-content-center" )
      div( class="col-lg-8" )
        div( class="ibox" )
          div( class="ibox-content text-center p-5" )
            h1( class="mb-4" ) Moonpull "Classic" is being retired

            p( class="mb-3" )
              | We've been hard at work creating "Callisto" - a faster, better, and more feature-rich platform
              | that continues to provide high quality affiliate link audit data, as well as a host
              | of additional features including AI-driven analytics and much more.
            
            p( class="mb-3" )
              | You can still access all of your data here, but you can no longer submit new audits 
              | via the Classic platform.

            p( class="mb-3" )
              | You can use our new platform right now by visiting
              |
              a( href="https://callisto.mnpll.com" target="_blank" )
                | Moonpull Callisto
                i( class="fa fa-external-link ml-1" )
              |
              | and using your exact same Moonpull login.

            p( class="mb-0" )
              | If you have any questions or concerns at all please don't hesitate to contact
              |
              a( href="mailto:client.service@moonpullpartners.com" ) client.service@moonpullpartners.com

            div( v-if="canUseRetiredSubmission" class="mt-4" )
              router-link( class="btn btn-primary" to="/link-checker/submission" )
                | Go to submission anyway
                i( class="fa fa-arrow-right ml-2" )

</template>

<script>
import Vue from "vue";
import { canUseRetiredLinkSubmission } from "@/linkSubmissionAllowlist";
export default Vue.extend({
  computed: {
    canUseRetiredSubmission() {
      return canUseRetiredLinkSubmission(
        this.$moonpull.getCurrentUserSession()
      );
    },
  },
  beforeCreate() {
    analytics.page(" view", {
      path: window.location.hash,
      referrer: window.location.hash,
    });
  },
});
</script>
